export default __webpack_public_path__ + "static/media/screen-relogio.cd888e08.png";